import {useCallback} from 'react';
import {useQueryClient} from './react-query';

export function useUpdateQueryCache<TData>({key}: {key: string}) {
  const queryClient = useQueryClient();

  return useCallback(
    async (state: TData) => {
      queryClient.setQueryData<TData>(key, state);
    },
    [key, queryClient],
  );
}
